<template>
    <Modal
        @close="close"
        title="Kreator rachunku"
        @submit="submit"
        :actions="modalActions"
    >
        <EditSection
            accent="apple"
            :errors="errors"
            :sections="sections"
            ref="sections"
            section="sections"
        />
    </Modal>
</template>
<script>
export default {
    props: {
        selectedItem: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            loading: false,
            errors: new this.$Errors(),
            sections: {
                mail: {
                    required: true,
                    title: 'Adres E-mail',
                    value: '',
                    type: 'text-input',
                    email: true,
                    key: 'mail',
                    color: '#FFF'
                },
                customer: {
                    required: true,
                    title: 'Imię i nazwisko',
                    value: '',
                    type: 'text-input',
                    key: 'customer',
                    color: '#FFF'
                }
            }
        }
    },
    computed: {
        modalActions() {
            return [
                {
                    color: 'apple',
                    action: 'submit',
                    display: 'Dodaj',
                    loading: this.loading
                }
            ]
        }
    },
    methods: {
        close() {
            this.$emit('close')
        },
        async submit() {
            if (this.loading) {
                return
            }
            this.loading = true
            const dataToSend = {
                title: `${this.sections.customer.value} ${this.selectedItem.uuid}`,
                mail: this.sections.mail.value,
                uuid: this.selectedItem.uuid
            }
            try {
                await this.$api.post(`v1/marketplace/manual`, dataToSend)
                this.$Notif.success()
                this.$emit('close')
            } catch (error) {
                this.$Network.handleError(error)
                this.loading = false
            }
        }
    }
}
</script>
